module.exports = __webpack_public_path__ + "img/instagram.c2def738.png";